import {Injectable,inject} from '@angular/core';
import {HttpService} from './http.service';
import {Observable,catchError,map,tap,throwError} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';
import {LoginResponse} from '../models/user.model';
import {Router} from '@angular/router';
import {projectStore} from '../stores/project.store';
import { Agent, AiConfig, Model, Tool, ToolCatalogEntry, VectorStore } from '../models/eruai.model';

@Injectable({
    providedIn:'root'
})
export class EruaiService{
    private router = inject(Router);
    constructor(private httpService:HttpService){}

    fetchConfig(url:string,project_name:string):
    Observable<{project:AiConfig}>{
        return this.httpService.get<any>(
            `${url}/store/${project_name}/config`
        ).pipe(
            map(response=>{
                if(response && response.project){
                    return {project:response.project};
                }else{
                    return {project:{}};
                }
            }),
            catchError((error:HttpErrorResponse)=>{
                console.error('API Error:',error);
                return throwError(()=>new Error(error.error?.error||'Projects not found'));
            })
        )
    } 

    saveModel(url:string,project_name:string,tenant_id: string,modelData:Model):Observable<any>{
        return this.httpService.post<any>(
            `${url}/store/${project_name}/${tenant_id}/save/model`,
            modelData
        ).pipe(tap(response=>console.log('Model saved successfully:',response)),
    catchError((error:HttpErrorResponse)=>{
        console.error('API Error:', error);
                return throwError(() => new Error(error.error?.error || 'Failed to save Model'));
    }));
    }

    deleteModel(url:string,project_name:string,tenant_id:string,model_name:string):Observable<any>{
        return this.httpService.delete<any>(
            `${url}/store/${project_name}/${tenant_id}/remove/model/${model_name}`
        ).pipe(
            catchError((error:HttpErrorResponse)=>{
              console.log('API Error:',error);
              return throwError(()=>new Error(error.error?.error||'Failed to delete Model'))
            })
          )
    }

    saveTool(url:string,project_name:string,tenant_id:string,toolData:Tool):Observable<any>{
        return this.httpService.post<any>(
            `${url}/store/${project_name}/${tenant_id}/save/tool`,
            toolData
        ).pipe(tap(response=>console.log('Tool saved successfully:',response)),
    catchError((error:HttpErrorResponse)=>{
        console.error('API Error:', error);
                return throwError(() => new Error(error.error?.error || 'Failed to save Tool'));
    }));
    }

    deleteTool(url:string,project_name:string,tenant_id:string,tool_name:string):Observable<any>{
        return this.httpService.delete<any>(
            `${url}/store/${project_name}/${tenant_id}/remove/tool/${tool_name}`
        ).pipe(tap(response=>console.log('Tool deleted successfully:',response)),
        catchError((error:HttpErrorResponse)=>{
            console.error('API Error:', error);
                    return throwError(() => new Error(error.error?.error || 'Failed to delete Tool'));
        }));
    }

    saveAgent(url:string,project_name:string,tenant_id:string,agentData:Agent):Observable<any>{
        return this.httpService.post<any>(
            `${url}/store/${project_name}/${tenant_id}/save/agent`,
            agentData
        ).pipe(tap(response=>console.log('Agent saved successfully:',response)),
        catchError((error:HttpErrorResponse)=>{
            console.error('API Error:', error);
                    return throwError(() => new Error(error.error?.error || 'Failed to save Agent'));
        }));
    }

    deleteAgent(url:string,project_name:string,tenant_id:string,agent_name:string):Observable<any>{
        return this.httpService.delete<any>(
            `${url}/store/${project_name}/${tenant_id}/remove/agent/${agent_name}`
        ).pipe(tap(response=>console.log('Agent deleted successfully:',response)),
        catchError((error:HttpErrorResponse)=>{
            console.error('API Error:', error);
                    return throwError(() => new Error(error.error?.error || 'Failed to delete Agent'));
        }));
    }

    fetchToolCatalog(url:string,project_name:string):Observable<ToolCatalogEntry[]>{
        return this.httpService.get<ToolCatalogEntry[]>(
            `${url}/store/${project_name}/tool/catalog`
        ).pipe(
            catchError((error:HttpErrorResponse)=>{
                console.error('API Error:', error);
                return throwError(() => new Error(error.error?.error || 'Failed to fetch tool catalog'));
            })
        );
    }

    saveVectorStore(url:string,project_name:string,tenant_id:string,vectorStore:VectorStore):Observable<any>{
        return this.httpService.post<any>(
            `${url}/store/${project_name}/${tenant_id}/save/vectorstore`,
            vectorStore
        ).pipe(
            catchError((error:HttpErrorResponse)=>{
                console.error('API Error:', error);
                return throwError(() => new Error(error.error?.error || 'Failed to save Vector Store'));
            })
        );
    }

    deleteVectorStore(url:string,project_name:string,tenant_id:string,vector_name:string):Observable<any>{
        return this.httpService.delete<any>(
            `${url}/store/${project_name}/${tenant_id}/remove/vectorstore/${vector_name}`
        ).pipe(
            catchError((error:HttpErrorResponse)=>{
                console.error('API Error:', error);
                return throwError(() => new Error(error.error?.error || 'Failed to delete Vector Store'));
            })
        );
    }

    saveVariables(url: string, project_name: string, tenant_id: string, secretPayload: { secret_value: { [key: string]: string } }): Observable<any> {
        return this.httpService.post<any>(`${url}/store/${project_name}/${tenant_id}/sm/set`, secretPayload).pipe(
          tap((response) => console.log('Variable saved successfully:', response)),
          catchError((error: HttpErrorResponse) => {
            console.error('API Error:', error);
            return throwError(() => new Error(error.error?.error || 'Failed to save Variable'));
          })
        );
      }
    
      // Assuming delete follows a similar structure
      deleteVariables(url: string, project_name: string, tenant_id: string, secretPayload: { secret_value: { [key: string]: null } }): Observable<any> {
        return this.httpService.post<any>(`${url}/store/${project_name}/${tenant_id}/sm/unset`, secretPayload).pipe(
          tap((response) => console.log('Variable deleted successfully:', response)),
          catchError((error: HttpErrorResponse) => {
            console.error('API Error:', error);
            return throwError(() => new Error(error.error?.error || 'Failed to delete Variable'));
          })
        );
      }
    loginWithUserPassword(url: string, username: string, password: string): Observable<LoginResponse> {
        return this.httpService.post<LoginResponse>(
          url,
          { username, password }
        ).pipe(
          catchError((error: HttpErrorResponse) => {
            console.error('API Error:', error);
            return throwError(() => new Error(error.error?.error || 'Login failed'));
          })
        );
      }

    
}